const STORAGE_KEY = 'arunvilkasa_consent_v1'
const EVENT_NAME = 'arunvilkasa:consent-changed'

const defaultState = {
  necessary: true,
  external: false, // e.g. Google Maps
  analytics: false
}

export function getConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...defaultState }
    const parsed = JSON.parse(raw)
    return { ...defaultState, ...(parsed || {}) }
  } catch (e) {
    return { ...defaultState }
  }
}

export function setConsent(partial) {
  const next = { ...getConsent(), ...(partial || {}) }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch (e) {
    // ignore
  }
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: next }))
  return next
}

export function onConsentChange(handler) {
  const wrapped = (e) => handler(e?.detail || getConsent())
  window.addEventListener(EVENT_NAME, wrapped)
  return () => window.removeEventListener(EVENT_NAME, wrapped)
}

export function openCookieSettings() {
  window.dispatchEvent(new CustomEvent('arunvilkasa:open-cookie-settings'))
}


